/* src/app/component/edizione/edizione.component.css */
:host-context(app-edizione) .gridL {
  display: grid;
}
:host-context(app-edizione) .gridL {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
:host-context(app-edizione) .gridL {
  gap: 1rem;
}
@media (min-width: 640px) {
  :host-context(app-edizione) .gridL {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (min-width: 768px) {
  :host-context(app-edizione) .gridL {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  :host-context(app-edizione) .gridL {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {
  :host-context(app-edizione) .gridL {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
:host-context(app-edizione) .is__invalid-input {
  border-color: #e11d48;
}
:host-context(app-edizione) .is__invalid-error {
  color: #e11d48;
}
:host-context(app-edizione) .is__invalid-error {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
:host-context(app-edizione) .is__invalid-error {
  padding-top: 0.25rem;
}
:host-context(app-edizione) .is__invalid-error {
  font-size: 0.75rem;
  line-height: 1rem;
}
:host-context(app-edizione) .eye {
  height: 1rem;
  width: auto;
}
/*# sourceMappingURL=edizione.component.css.map */
